const getCardImageReducer = (state = { cardImageState:{} }, action) => {

    
          switch (action.type) {
              case "CARD_IMAGE_STATE":
                  return {
                    cardImageState: action.cardImageState
                  }
              default:
                  return state
          }
      }
      
      export default getCardImageReducer;


// WEBPACK FOOTER //
// ./src/reducer/getcardImagereducer.jsx